/** @format */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  LoginInitialState,
  LoginState,
  SendVerificationCode,
  loginDto,
} from './models';
import { GetOtp, VerifyOtp, login } from './loginApi';
import { RootState } from '../../app/store';
import { HasErrors } from '../../common/Logic/ServerResponse';

const initialState: LoginInitialState = {
  loginState: {} as LoginState,
};

export const loginThunk = createAsyncThunk(
  'login',
  async (payload: loginDto) => {
    let response: any;
    await login(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const GetOtpThunk = createAsyncThunk(
  'GetOtp',
  async (identityNumber: string) => {
    let response: any;
    await GetOtp(identityNumber)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const VerifyOtpThunk = createAsyncThunk(
  'VerifyOtp',
  async (payload: SendVerificationCode) => {
    let response: any;
    await VerifyOtp(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.loginState.status = 'loading';
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        const hasErrors = HasErrors(action);
        if (hasErrors === 1) {
          state.loginState.status = 'failed';
          state.loginState.error = action.payload;
        } else if (hasErrors === 3 || hasErrors === 2) {
          state.loginState.login = action.payload;
          state.loginState.status = 'idle';
        }
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.loginState.status = 'failed';
        state.loginState.error = action.payload;
      });

    builder
      .addCase(GetOtpThunk.pending, (state) => {
        state.loginState.status = 'loading';
      })
      .addCase(GetOtpThunk.fulfilled, (state, action) => {
        const hasErrors = HasErrors(action);
        if (hasErrors === 1) {
          state.loginState.status = 'failed';
          state.loginState.error = action.payload;
        } else if (hasErrors === 3 || hasErrors === 2) {
          const d = action.payload?.data;
          const seconds =
            d && typeof d === 'object' && d !== null && 'expiryDate' in d
              ? Number((d as { expiryDate: number }).expiryDate)
              : Number(d);
          state.loginState.expiryDate = Number.isFinite(seconds) ? seconds : 0;
          state.loginState.status = 'idle';
        }
      })
      .addCase(GetOtpThunk.rejected, (state, action) => {
        state.loginState.status = 'failed';
        state.loginState.error = action.payload;
      });

    builder
      .addCase(VerifyOtpThunk.pending, (state) => {
        state.loginState.status = 'loading';
      })
      .addCase(VerifyOtpThunk.fulfilled, (state, action) => {
        const hasErrors = HasErrors(action);
        if (hasErrors === 1) {
          state.loginState.status = 'failed';
          state.loginState.error = action.payload;
        } else if (hasErrors === 3 || hasErrors === 2) {
          state.loginState.login = action.payload.data;
          state.loginState.status = 'idle';
        }
      })
      .addCase(VerifyOtpThunk.rejected, (state, action) => {
        state.loginState.status = 'failed';
        state.loginState.error = action.payload;
      });
  },
});

export const {} = loginSlice.actions;
export const selectLogin = (state: RootState) => state.login;
export default loginSlice.reducer;
